NIRV.refreshMain = function (callback) {
  DEBUG && console.log(' NIRV.refreshMain()');

  NIRV.autosave = false;

  var highlight_taskids = NIRV.highlighted_tasks();
  $('#main .tasklist').each(function () {
    var key = $(this).attr('key');
    NIRV.tasklists[key]?.recalc();
    NIRV.tasklists[key]?.redraw();
  });
  NIRV.highlight_tasks(highlight_taskids);

  NIRV.refreshHelp();
  NIRV.refreshRapidEntry();
  NIRV.refreshTips();
  NIRV.hideEmptyTasklists();
  NIRV.sortable();

  if (typeof callback == 'function') {
    callback();
  }

  NIRV.autosave = true;
};

NIRV.refreshHelp = function () {
  DEBUG && VERBOSE && console.log('  NIRV.refreshHelp()');

  var html = '';

  html += '<span class="inner">';
  html += '<span class="closex">x</span>';

  html +=
    "<span style='width:160px;float:right; border-left: 1px dotted #cc9; margin: 2.4em 0 1em 2em; padding-left: 1.5em;'><i>" +
    NIRV.L.help_panel_toggle_text +
    "</i> <span class='hotkey'>Shift</span>+<span class='hotkey'>h</span></span>";

  if (NIRV.q != '') {
    html +=
      '<h1>' +
      NIRV.L.search_tips_title +
      '</h1>' +
      NIRV.L.search_tips_description +
      '<br>';
  } else if (NIRV.currentview == 'inbox') {
    html +=
      '<h1>' +
      NIRV.L.inbox_help_title +
      '</h1>' +
      NIRV.L.inbox_help_description;
  } else if (NIRV.currentview == 'focus') {
    html +=
      '<h1>' +
      NIRV.L.focus_help_title +
      '</h1>' +
      NIRV.L.focus_help_description;
  } else if (NIRV.currentview == 'next') {
    html +=
      '<h1>' + NIRV.L.next_help_title + '</h1>' + NIRV.L.next_help_description;
  } else if (NIRV.currentview == 'later') {
    html +=
      '<h1>' +
      NIRV.L.later_help_title +
      '</h1>' +
      NIRV.L.later_help_description;
  } else if (NIRV.currentview == 'waiting') {
    html += '<h1>' + NIRV.L.waiting + '</h1>' + NIRV.L.waiting_description_text;
  } else if (NIRV.currentview == 'scheduled') {
    html +=
      '<h1>' +
      NIRV.L.scheduled_help_title +
      '</h1>' +
      NIRV.L.scheduled_help_description;
  } else if (NIRV.currentview == 'someday') {
    html +=
      '<h1>' +
      NIRV.L.someday_help_title +
      '</h1>' +
      NIRV.L.someday_help_description;
  } else if (NIRV.currentview == 'projects') {
    html +=
      '<h1>' +
      NIRV.L.projects_help_title +
      '</h1>' +
      NIRV.L.projects_help_description;
  } else if (NIRV.currentview[0] == 'p' && NIRV.currentview != 'projects') {
    html +=
      '<h1>' +
      NIRV.L.project_help_title +
      '</h1>' +
      NIRV.L.project_help_description;
  } else if (NIRV.currentview == 'logbook') {
    html +=
      '<h1>' +
      NIRV.L.logbook_help_title +
      '</h1>' +
      NIRV.L.logbook_help_description;
  } else if (NIRV.currentview == 'trash') {
    html +=
      '<h1>' +
      NIRV.L.trash_help_title +
      '</h1>' +
      NIRV.L.trash_help_description +
      '<br>';
  } else if (NIRV.currentview == 'reflists') {
    html +=
      '<h1>' +
      NIRV.L.reference_lists_help_title +
      '</h1>' +
      NIRV.L.reference_lists_help_description;
  } else if (NIRV.currentview[0] == 'l') {
    html +=
      '<h1>' +
      NIRV.L.reference_items_help_title +
      '</h1>' +
      NIRV.L.reference_items_help_description;
  } else if (NIRV.currentview[0] == 'g') {
    html +=
      '<h1>' +
      NIRV.L.tag_cloud_help_title +
      '</h1>' +
      NIRV.L.tag_cloud_description_text;
  }

  html += '</span>';

  if (
    NIRV.prefs.UIBShowSidebarHelp &&
    NIRV.prefs.UIBShowSidebarHelp.value == 1
  ) {
    $('#help').show();
  } else {
    $('#help').hide();
  }

  $('#help').html(html);
};

NIRV.refreshRapidEntry = function () {
  var html = `
  <form 
    class="rapidentry" 
    autocomplete="off" 
    onsubmit="return false;">
    <input 
      class="rapidentry" 
      type="text" 
      name="r2" 
      value="" 
      placeholder="${NIRV.L.rapid_entry_placeholder}" 
      autocomplete="off" />
  </form>
  <div class="clear"></div>`;
  $('#rapidentry').html(html);

  if (
    NIRV.prefs.UIEnableRapidEntry &&
    NIRV.prefs.UIEnableRapidEntry.value == 1 &&
    NIRV.currentview != 'trash' &&
    NIRV.currentview != 'search'
  ) {
    $('#rapidentry').show();
  } else {
    $('#rapidentry').hide();
  }
};

NIRV.collapseCompletedTasklists = function () {
  var projects = NIRV.projects();
  for (var i = 0; i < projects.length; i++) {
    NIRV.collapse['p' + projects[i].id + ':project.completed'] = true;
    NIRV.collapse['p' + projects[i].id + ':project.logged'] = true;
  }
  NIRV.collapse['inbox:inbox.completed'] = true;
  NIRV.collapse['next:next.completed'] = true;
  NIRV.collapse['later:later.completed'] = true;
  NIRV.collapse['scheduled:scheduled.completed'] = true;
  NIRV.collapse['someday:someday.completed'] = true;
  NIRV.collapse['projects:projects.completed'] = true;
};

NIRV.sortable = function () {
  DEBUG && console.log(' NIRV.sortable()');
  $('#main .tasklist ul.tasks:not(.prompt)').sortable({
    placeholder: 'placeholder',
    forcePlaceholderSize: true,
    distance: 5,
    cursor: 'default',
    tolerance: 'pointer',
    cancel: '.edit',
    start: function () {
      NIRV.autosave = false;
    },
    stop: function () {
      NIRV.autosave = true;
    },
    receive: function (event, ui) {
      var listid = $(event.target).parent().attr('listid');
      var taskid = $(ui.item[0]).attr('taskid');
      var task = NIRV.tasks[taskid];
      if (listid == 'inbox') {
        task.set('state', 0);
      } else if (listid == 'next') {
        task.set('state', 1);
      } else if (listid == 'someday') {
        task.set('state', 4);
      } else if (listid == 'trash') {
        task.set('state', 6);
      }
    },
    update: function (event, ui) {
      var sortby = $(this).attr('sortby');
      if (sortby != undefined && sortby.slice(0, 3) != 'seq') {
        return false;
      }
      NIRV.reseqeuence_and_save($(ui.item));
    },
  });
};

NIRV.reseqeuence_and_save = debounce(function (items) {
  // DEBUG && console.log(Date.now() + ' NIRV.reseqeuence_and_save() ')
  // DEBUG && console.log(items);
  // DEBUG && console.log(items.length);

  var tasklists = {},
    taskids = [],
    i,
    $ul,
    sortby,
    position;

  for (i = 0; i < items.length; i++) {
    // DEBUG && console.log(items[i]);
    tasklists[$(items[i]).closest('.tasklist').attr('key')] = $(
      items[i]
    ).closest('.ui-sortable');
    taskids.push($(items[i]).attr('taskid'));
  }

  for (i in tasklists) {
    // DEBUG && console.log($(tasklists[i]).closest('.tasklist').attr('key'));

    $ul = $(tasklists[i]);
    sortby = $ul.attr('sortby');
    // DEBUG && console.log(sortby);

    position = 1;
    if (sortby != undefined && sortby.slice(0, 3) == 'seq') {
      $ul.children('li.task').each(function () {
        if (
          NIRV.tasks[$(this).attr('taskid')] &&
          typeof NIRV.tasks[$(this).attr('taskid')].set == 'function'
        ) {
          NIRV.tasks[$(this).attr('taskid')].set(sortby, position++);
        }
      });
    }
  }

  NIRV.recalcWtasks();
  // NIRV.refreshMain()
  NIRV.highlight_tasks(taskids);

  // update active projects in #east
  if (NIRV.currentview == 'projects' || NIRV.currentview == 'reflists') {
    NIRV.refreshEast();
    NIRV.reflow();
  }

  fireAndForget(NIRV.sync(), 'NIRV.sync');
}, 200);

NIRV.scrollLiIntoView = function ($li) {
  if ($li.length != 0) {
    var north_cbar_height =
      $('#north').outerHeight() + $('#cbar').outerHeight();
    var viewable_top = $(window).scrollTop() + north_cbar_height;
    var viewable_bottom = $(window).height() + $(window).scrollTop();
    var li_top = $li.offset().top;
    var li_bottom = li_top + $li.outerHeight();
    var hidden_px = 0;
    var window_scrolltop = 0;

    if (li_bottom > viewable_bottom) {
      hidden_px = li_bottom - viewable_bottom;
      window_scrolltop = $(window).scrollTop() + hidden_px + 60;
      $('html,body').animate(
        {
          scrollTop: window_scrolltop,
        },
        100
      );
    } else if (li_top < viewable_top) {
      hidden_px = viewable_top - li_top;
      window_scrolltop = $(window).scrollTop() - hidden_px - 40;
      $('html,body').animate(
        {
          scrollTop: window_scrolltop,
        },
        100
      );
    }
  }
};

NIRV.highlight_tasks = function (taskids) {
  DEBUG && console.log(' NIRV.highlight_tasks(' + taskids + ')');
  $('.ui-selected').removeClass('ui-selected');
  if (!$('html').hasClass('editing')) {
    if (taskids === undefined) {
      // TBD - highlight previously highlighted (somehow)
    } else if (taskids === false) {
      // removes highlighting
    } else {
      for (var i = 0; i < taskids.length; i++) {
        $('#main li.task[taskid=' + taskids[i] + ']').addClass('ui-selected');
      }
    }
  }
  NIRV.draggable();
};

NIRV.highlighted_tasks = function () {
  var taskids = [];
  $('#main li.task.ui-selected').each(function () {
    taskids.push($(this).attr('taskid'));
  });
  return taskids;
};

NIRV.refreshMultiselectDataPos = function () {
  DEBUG && VERBOSE && console.log('NIRV.refreshMultiselectDataPos()');
  var xx = 0;
  $('#main li.task:visible').each(function () {
    $(this).attr('data-pos', xx++);
  });
};

NIRV.alert = function (message) {
  message = message || 'Alert';
  var html = '';
  html += '<p>' + message + '</p>';
  $('#alert').html(html);
  $('#alert').dialog({
    autoOpen: true,
    closeOnEscape: true,
    dialogClass: 'NIRV_alert',
    title: '',
    height: 'auto',
    minHeight: 0,
    width: 360,
    modal: true,
    resizable: false,
    position: NIRV.dialog_position_default,
    buttons: {
      OK: function () {
        $(this).dialog('close');
      },
    },
    open: function () {},
    close: function () {},
  });
};

NIRV.confirm = function (message, callback) {
  message = message || 'Are you sure?';
  var html = '';
  html += '<p>' + message + '</p>';
  $('#confirm').html(html);
  $('#confirm').dialog({
    autoOpen: true,
    closeOnEscape: true,
    dialogClass: 'NIRV_confirm',
    title: '',
    height: 'auto',
    minHeight: 0,
    width: 360,
    modal: true,
    resizable: false,
    position: NIRV.dialog_position_default,
    buttons: {
      OK: function () {
        callback();
        $(this).dialog('close');
      },
      Cancel: function () {
        $(this).dialog('close');
      },
    },
    open: function () {},
    close: function () {},
  });
};
